import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";

import { watcherSaga } from "./sagas/rootSaga";

import partOffersReducer from "./entities/partOffers";
import partRequestsReducer from "./entities/partRequest";
import partUserReducer from "./entities/userFilters";
import storeDataReducer from "./entities/userFIlterStore";
import userFiltersReducer from "./entities/userFiltersStore";
import messagesReducer from "./entities/messages";
import configsReducer from "./entities/configs";
import addressesReducer from "./entities/addresses"



const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  router: routerReducer,
  partOffers: partOffersReducer,
  partRequests: partRequestsReducer,
  userFilters: partUserReducer,
  storeData: storeDataReducer,
  userFiltersStore: userFiltersReducer,
  configs: configsReducer,
  messages: messagesReducer,
  addresses: addressesReducer

});

const sellerStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware,
    routerMiddleware,
  ],
});

const sellerHistory = createReduxHistory(sellerStore);

sagaMiddleware.run(watcherSaga);

export { sellerStore, sellerHistory };
